import React, { useState, useEffect, useContext, useRef } from "react";
import { useForm } from "react-hook-form";
import {
  apiGetRequest,
  apiPostRequest,
  apiPutRequest,
} from "../../../helpers/Requests";
import _ from "lodash";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import CircularLoader from "../../common/CircularLoader/CircularLoader";
import SideBar from "../../common/SideBar/SideBarNew";
import AlertModal from "../../Modals/alertModal";
import {
  baseURLImage,
  collectDrawnSignatures,
  convertLabelIntoName,
  findStoredFormSignature,
  formatDateIntoDMYToDisplay,
  freshSignatureUploads,
  mergeFormSignatures,
  normalizeStoredSignatures,
  getFormSubTabForParticipantProfile,
  getUrlRole,
  parseBooleanVal,
  selectedTabState,
  textTruncate,
} from "../../../Utils/utils";
import { getMissingRequiredDynamicFormFileLabels } from "../../../Utils/dynamicFormFileValidation";
import {
  dynamicFormInvalidSubmitToast,
  hydrateSubmittedTemplateForRhf,
  isDynamicFormSaveBlocked,
  parseSubmittedFormSignatures,
  resolveWatchFormPayload,
  seedStoredSignatureValidationDefaults,
} from "../shared/dynamicFormSaveUtils";
import { LoginContext } from "../../../helpers/LoginContext";
import { getNameProfile } from "../../../Utils/utils";
import HumanBodyModal from "../../Modals/HumanBody/HumanBodyModal";
import CustomButton from "../../common/Button/CustomButton";
import { USER_ROLE } from "../../../Constants/constant";
import { roleAccess } from "helpers/RolesPermission";
import SectionInputFields from "../SectionAndSubSectionFields/SectionsInputFields";
import { useSelector } from "react-redux";
import { getUser } from "store/selector/auth.selector";
import Stepper from "../Stepper/Stepper";
import {
  FormPageBreadcrumb,
  FormPageHeader,
  FormMetaStrip,
  FormPageLoader,
  buildSubmittedFormMetaItems,
  useFormPageHeaderHeight,
} from "../shared/FormPageLayout";

const SubmittedFormUpdate = () => {
  const navigate = useNavigate();
  const { sideBarPadding } = useContext(LoginContext);
  const { formId, parentSlug } = useParams();
  const location = useLocation();
  const { state } = location;
  const [template, setTemplate] = useState([]);
  const [templateForm, setTemplateForm] = useState([]);
  const [request, setRequest] = useState({
    isRequested: false,
    isSuccess: false,
    isFailed: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSaveExitLoading, setIsSaveExitLoading] = useState(false);
  const [fileUploadChecker, setFileUploadChecker] = useState(true);
  const [Index, setIndex] = useState(0);
  const [participantList, setParticipantList] = useState([]);
  const [selectedLegal, setSelectedLegal] = useState("");
  const [signatures, setSignatures] = useState([]);
  const [fileLoader, setFileLoader] = useState("");
  const [openBodyModal, setOpenBodyModal] = useState(false);
  const [selectedBody, setSelectedBody] = useState("");
  const [updatedBody, setUpdateBody] = useState("");
  const [fieldName, setFieldName] = useState();
  const sigCanvasManager = useRef({});
  const signatureReplaceNameRef = useRef({});
  const pageRef = useRef(null);
  const headerRef = useRef(null);
  const scrollRef = useRef(null);
  const currentUser = useSelector(getUser);

  const {
    register,
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  const watchFormData = watch();

  useEffect(() => {
    if (state && !state.hasOwnProperty("particpantUuid")) {
      navigate("/");
    }
    fetchTemplate();
  }, [location]);

  useEffect(() => {
    if (template.length > 0) {
      reset({ template: hydrateSubmittedTemplateForRhf(template) });
    }
  }, [template, reset]);

  useEffect(() => {
    if (template.length > 0) {
      seedStoredSignatureValidationDefaults(
        template,
        signatures,
        setValue,
        Index
      );
    }
  }, [template, signatures, Index, setValue]);

  useEffect(() => {
    return () => {
      if (
        state &&
        state.hasOwnProperty("redirectTo") &&
        state.hasOwnProperty("particpantUuid") &&
        getFormSubTabForParticipantProfile(parentSlug)
      ) {
        navigate(
          `/${
            roleAccess([USER_ROLE.Sp_Standard_User])
              ? "participant-profile"
              : "worker-profile"
          }/${state.particpantUuid}`
        );
      } else if (getFormSubTabForParticipantProfile(parentSlug)) {
        selectedTabState.save(
          JSON.stringify(getFormSubTabForParticipantProfile(parentSlug))
        );
      }
    };
  }, []);

  const fetchTemplate = async () => {
    setRequest({ ...request, isRequested: true });
    try {
      let res = await apiGetRequest(
        `${getUrlRole()}/employee/submitted-forms-view?form_id=${formId}`
      );

      if (res.status !== 200) {
        setRequest({ ...request, isRequested: false, isFailed: true });
        console.log("Something Went Wrong");
      }
      if (res.status === 200) {
        setRequest({ ...request, isRequested: false, isSuccess: true });
        if (res?.data?.submitted_form?.template?.length > 0) {
          const data = JSON.parse(res?.data?.submitted_form?.template).map(
            (step, stepIndex) => {
              step.status = stepIndex === 0 ? "current" : "";
              return step;
            }
          );
          countTotalSignatureFields(data);
          setTemplateForm(res?.data?.submitted_form);
          // console.log("res?.data?.submitted_form", res?.data?.submitted_form);
          const parsedSignatures = parseSubmittedFormSignatures(
            res?.data?.submitted_form?.signatures
          );
          setTemplate(data);
          setSignatures(normalizeStoredSignatures(parsedSignatures));
        }
      }
      setRequest({ ...request, isRequested: false, isFailed: false });
    } catch (err) {
      setRequest({ ...request, isRequested: false, isFailed: false });
      console.log(err.message);
    }
  };

  const MAX_FORM_ATTACHMENT_BYTES = 2 * 1024 * 1024;

  const fileUploadHandler = async (
    e,
    sectionIndex,
    fieldIndex,
    subSectionIndex = null
  ) => {
    const selectedFile = e.target.files?.[0];
    if (!selectedFile) return;
    if (selectedFile.size > MAX_FORM_ATTACHMENT_BYTES) {
      toast.error(
        "File too large. The maximum allowed size is 2MB. Try a smaller file."
      );
      e.target.value = "";
      return;
    }
    setFileUploadChecker(false);
    let fileLoaderName = `${sectionIndex}-${fieldIndex}`;
    if (subSectionIndex !== null) {
      fileLoaderName = `${fileLoaderName}-${subSectionIndex}`;
    }
    setFileLoader(fileLoaderName);
    const formData = new FormData();
    formData.append("form_file", selectedFile);
    try {
      let res = await apiPostRequest(
        `${getUrlRole()}/hrm/form-data-file`,
        formData
      );
   
      if (res.status !== 200) {
        toast.error("File upload Failed");
        setFileUploadChecker(true);
      }
      if (res.status === 200) {
        toast.success("File uploaded successfully");
        const data = _.cloneDeep(template);
        if (subSectionIndex === null) {
          data[sectionIndex].input_fields[fieldIndex].path = `${res.data.path}`;
          data[sectionIndex].input_fields[
            fieldIndex
          ].value = `${selectedFile.name}`;
        } else {
          data[sectionIndex].input_fields[fieldIndex].sub_fields[
            subSectionIndex
          ].path = `${res.data.path}`;
          data[sectionIndex].input_fields[fieldIndex].sub_fields[
            subSectionIndex
          ].value = `${selectedFile.name}`;
        }
        setTemplate([...data]);
        setFileUploadChecker(true);
      }
      setFileUploadChecker(true);
      setFileLoader(null);
    } catch (err) {
      toast.error(
        err?.message || "File upload failed. Please try again."
      );
      setFileLoader(null);
      setFileUploadChecker(true);
      e.target.value = "";
    }
  };

  const navigateAfterSave = () => {
    if (
      templateForm &&
      (templateForm?.participant_uuid || templateForm?.worker_uuid)
    ) {
      if (getFormSubTabForParticipantProfile(parentSlug) && !state) {
        selectedTabState.save(
          JSON.stringify(getFormSubTabForParticipantProfile(parentSlug))
        );
      }
      navigate(
        `/${
          roleAccess([USER_ROLE.Sp_Standard_User])
            ? "participant-profile"
            : "worker-profile"
        }/${templateForm?.participant_uuid ?? templateForm?.worker_uuid}`
      );
    }
  };

  const nextStep = (formatedData) => {
    const data = _.cloneDeep(formatedData || template);
    data[Index].status = "complete";
    if (Index + 1 < data.length) {
      data[Index + 1].status = "current";
      setIndex(Index + 1);
    }
    setTemplate([...data]);
    scrollRef.current?.scrollTo?.(0, 0);
  };

  const submitFormData = async (
    formData,
    formatedData,
    { isExitAfterSave = false, isFinalSection = false } = {}
  ) => {
    const missingFiles =
      getMissingRequiredDynamicFormFileLabels(formatedData);
    if (missingFiles.length > 0) {
      toast.error(
        missingFiles.length === 1
          ? `Please upload the required file: ${missingFiles[0]}.`
          : `Please upload all required files: ${missingFiles.join(", ")}.`
      );
      return;
    }

    const supportPlan = [];
    formatedData.forEach((obj) => {
      obj.input_fields.forEach((x) => {
        if (
          x.type !== "sub_section" &&
          parseBooleanVal(x.isSupportPlan) &&
          x.isSupportPlan
        ) {
          supportPlan.push(x);
        } else if (x.type === "sub_section") {
          x.sub_fields.forEach((y) => {
            if (parseBooleanVal(y.isSupportPlan) && y.isSupportPlan) {
              supportPlan.push(y);
            }
          });
        }
      });
    });

    const mergedSignatures = mergeFormSignatures(
      signatures,
      collectDrawnSignatures(formData)
    );
    setSignatures(mergedSignatures);

    const data = {
      worker_id:
        state && state.hasOwnProperty("participantId")
          ? state.participantId
          : "1",
      hrm_sp_form_temp_id: templateForm.id,
      created_by: currentUser.id,
      is_complete: true,
      template: formatedData,
    };

    const imageData = freshSignatureUploads(mergedSignatures);
    if (imageData.length > 0) {
      Object.assign(data, { signatures: imageData });
    } else {
      Object.assign(data, { signatures: null });
    }

    if (
      supportPlan.length > 0 &&
      templateForm &&
      templateForm?.title?.toLowerCase() === "initial assessment form"
    ) {
      Object.assign(data, { support_plan_data: JSON.stringify(supportPlan) });
    }
    if (isExitAfterSave) {
      setIsSaveExitLoading(true);
    } else {
      setIsSubmitting(true);
    }

    try {
      const res = await apiPutRequest(
        `${getUrlRole()}/employee/submitted-form-update?form_id=${formId}`,
        data
      );

      if (res.status === 200) {
        if (isExitAfterSave) {
          toast.success("Form saved successfully");
          navigateAfterSave();
          return;
        }

        if (!isFinalSection && Index < template.length - 1) {
          nextStep(formatedData);
          return;
        }

        toast.success("Form updated successfully");
        navigateAfterSave();
        return;
      }

      toast.error("Could not save the form. Please try again.");
    } catch (err) {
      toast.error(err?.message || "Something went wrong, try again!");
    } finally {
      setIsSubmitting(false);
      setIsSaveExitLoading(false);
    }
  };

  const dataFormatter = async (data) => {
  
    const temp = _.cloneDeep(template);
    temp.forEach((t, tempIndex) => {
      for (let j = 0; j < temp[tempIndex].input_fields.length; j++) {
        if (temp[tempIndex].input_fields[j].type === "address") {
          const address = data.template[tempIndex].input_fields[j]["address"];
          temp[tempIndex].input_fields[j].address = { ...address };
        }
        if (temp[tempIndex].input_fields[j].type === "sub_section") {
          temp[tempIndex].input_fields[j].sub_fields.map((item, k) => {
            if (
              temp[tempIndex].input_fields[j].sub_fields[k].type === "address"
            ) {
              const address =
                data.template[tempIndex].input_fields[j].sub_section[k][
                  "address"
                ];
              temp[tempIndex].input_fields[j].sub_fields[k].address = {
                ...address,
              };
            }
            if (
              temp[tempIndex].input_fields[j].sub_fields[k].type === "file" ||
              temp[tempIndex].input_fields[j].sub_fields[k].type === "signature" 
            ) {
              return null;
            }
            if (item.type !== "table" ) {
              if(item.type !== "content"){
              
              const name = convertLabelIntoName(item.lable);
              item.value =
                data.template[tempIndex].input_fields[j].sub_section[k][
                  `${name}`
                ];}
            } else {
              const rowDataTemp = _.cloneDeep(
                temp[tempIndex].input_fields[j].sub_fields[k].rows
              );
              let rows = [];
              temp[tempIndex].input_fields[j].sub_fields[k].rows.forEach(
                (rowData, rowIndex) => {
                  rows.push([]);
                  rowDataTemp[rowIndex].forEach((columnData, columnIndex) => {
                    rows[rowIndex].push({});
                    const name = convertLabelIntoName(
                      rowDataTemp[rowIndex][columnIndex].lable
                    );
                    Object.assign(rowDataTemp[rowIndex][columnIndex], {
                      value:
                        data.template[tempIndex].input_fields[j].sub_fields[k]
                          .rows[rowIndex].columns[columnIndex][name],
                    });
                    Object.assign(rows[rowIndex][columnIndex], {
                      ...rowDataTemp[rowIndex][columnIndex],
                    });
                  });
                }
              );
              Object.assign(temp[tempIndex].input_fields[j].sub_fields[k], {
                rows: [...rows],
              });
            }
            return item;
          });
        }
        if (
          temp[tempIndex].input_fields[j].type === "signature" ||
          temp[tempIndex].input_fields[j].type === "file"
        ) {
          continue;
        }
        if (temp[tempIndex].input_fields[j].type === "table") {
          const rowDataTemp = _.cloneDeep(temp[tempIndex].input_fields[j].rows);
          let rows = [];
          temp[tempIndex].input_fields[j].rows.forEach((rowData, rowIndex) => {
            rows.push([]);
            rowDataTemp[rowIndex].forEach((columnData, columnIndex) => {
              rows[rowIndex].push({});
              const name = convertLabelIntoName(
                rowDataTemp[rowIndex][columnIndex].lable
              );
              Object.assign(rowDataTemp[rowIndex][columnIndex], {
                value:
                  data.template[tempIndex].input_fields[j].rows[rowIndex]
                    .columns[columnIndex][name],
              });
              Object.assign(rows[rowIndex][columnIndex], {
                ...rowDataTemp[rowIndex][columnIndex],
              });
            });
          });
          Object.assign(temp[tempIndex].input_fields[j], { rows: [...rows] });
        } else {
          
          if (Object.keys(data).length !== 0  && data?.template[tempIndex]) {
            if (
              data.template[tempIndex].input_fields &&
              data.template[tempIndex].input_fields.length > 0 &&
              temp[tempIndex].input_fields[j] &&
              data.template[tempIndex].input_fields[j]
            ) {
              const name = convertLabelIntoName(
                temp[tempIndex].input_fields[j].lable
              );
              temp[tempIndex].input_fields[j].value =
                data.template[tempIndex].input_fields[j][`${name}`];
            }
          }
        }
      }
    });

    return [...temp];
  };

  const onSubmit = async (data) => {
    if (
      isDynamicFormSaveBlocked({
        fileUploadChecker,
        selectedBody,
        isBusy: isSubmitting || isSaveExitLoading,
      })
    ) {
      return;
    }
    const formatedData = await dataFormatter(data);
    await submitFormData(data, formatedData, {
      isFinalSection: Index === template.length - 1,
    });
  };

  const handleSaveAndExit = async () => {
    if (
      isDynamicFormSaveBlocked({
        fileUploadChecker,
        selectedBody,
        isBusy: isSubmitting || isSaveExitLoading,
      })
    ) {
      return;
    }
    if (!template?.length) {
      toast.error("Form is still loading. Please try again.");
      return;
    }
    const dataToFormat = resolveWatchFormPayload(watch(), template);
    const formatedData = await dataFormatter(dataToFormat);
    await submitFormData(dataToFormat, formatedData, {
      isExitAfterSave: true,
    });
  };

  const countTotalSignatureFields = (formData) => {
    if (!formData) return;

    formData.forEach((obj) => {
      obj.input_fields.forEach((x) => {
        if (x.type === "signature") {
          sigCanvasManager.current[`${x.name}`] = { ...x, current: null };
        } else if (x.type === "sub_section") {
          x.sub_fields.forEach((y) => {
            if (y.type === "signature") {
              sigCanvasManager.current[`${y.name}`] = { ...y, current: null };
            }
          });
        }
      });
    });
  };

  const formatIntoPngManager = (
    name,
    templateIndex,
    inputFieldIndex,
    SubFieldIndex = null,
    aliasName = null
  ) => {
    const canvas = sigCanvasManager.current?.[name]?.current;
    if (!canvas || typeof canvas.toDataURL !== "function") return null;
    if (typeof canvas.isEmpty === "function" && canvas.isEmpty()) return null;

    const existing = findStoredFormSignature(signatures, name, aliasName);
    const signatureName =
      signatureReplaceNameRef.current[name] ||
      (aliasName ? signatureReplaceNameRef.current[aliasName] : null) ||
      existing?.name ||
      name;
    delete signatureReplaceNameRef.current[name];
    if (aliasName) delete signatureReplaceNameRef.current[aliasName];
    const namesToReplace = new Set(
      [name, aliasName, signatureName].filter(Boolean)
    );
    setSignatures((prev) =>
      normalizeStoredSignatures(prev).filter(
        (item) => !namesToReplace.has(item.name)
      )
    );

    return {
      image: canvas.toDataURL(),
      name: signatureName,
      templateIndex,
      inputFieldIndex,
      SubFieldIndex,
    };
  };

  const clearSignatureManager = (
    canvasKey,
    validationKey = canvasKey,
    aliasName = null
  ) => {
    if (sigCanvasManager.current?.[canvasKey]?.current) {
      sigCanvasManager.current[canvasKey].current.clear();
    }
    const existing = findStoredFormSignature(signatures, canvasKey, aliasName);
    if (existing?.name) {
      signatureReplaceNameRef.current[canvasKey] = existing.name;
      if (aliasName) {
        signatureReplaceNameRef.current[aliasName] = existing.name;
      }
    }
    const namesToClear = new Set([canvasKey, aliasName].filter(Boolean));
    setSignatures((prev) =>
      normalizeStoredSignatures(prev).filter(
        (item) => !namesToClear.has(item.name)
      )
    );
    if (validationKey) {
      setValue(validationKey, null, { shouldValidate: true });
    }
  };

  const addRowHandler = (si, fi, sf = null) => {
    const data = _.cloneDeep(template);
    if (sf >= 0 && sf !== null) {
      data[si].input_fields[fi].sub_fields[sf].rows.push(
        data[si].input_fields[fi].sub_fields[sf].columns
      );
    } else {
      data[si].input_fields[fi].rows.push(data[si].input_fields[fi].columns);
    }
    setTemplate([...data]);
  };

  const delteRowHandler = (si, fi, ri, sf = null) => {
    const data = _.cloneDeep(template);
    if (sf !== null) {
      const rows = data[si].input_fields[fi].sub_fields[sf].rows;
      const rowsData =
        watchFormData.template[si].input_fields[fi].sub_fields[sf].rows;
      rows.splice(ri, 1);
      rowsData.splice(ri, 1);
      Object.assign(data[si].input_fields[fi].sub_fields[sf], {
        rows: [...rows],
      });
      setValue(`template[${si}].input_fields[${fi}].sub_fields[${sf}].rows`, [
        ...rowsData,
      ]);
    } else {
      const rows = data[si].input_fields[fi].rows;
      const rowsData = watchFormData.template[si].input_fields[fi].rows;
      rows.splice(ri, 1);
      rowsData.splice(ri, 1);
      Object.assign(data[si].input_fields[fi], {
        rows: [...rows],
      });
      setValue(`template[${si}].input_fields[${fi}].rows`, [...rowsData]);
    }
    setTemplate([...data]);
  };

  const handleImageError = (e, fname, lname) => {
    return (e.target.src = getNameProfile(fname, lname));
  };

  const handleAddOther = (sectionIndex = null, subSectionIndex = null) => {
    if (
      !isNaN(sectionIndex) &&
      !isNaN(subSectionIndex) &&
      sectionIndex !== null &&
      subSectionIndex !== null
    ) {
      const data = _.cloneDeep(
        template[sectionIndex].input_fields[subSectionIndex]
      );
      const newObj = { ...data, isAddOther: false, isAddOtherDelete: true };
      setTemplate(
        [...template],
        template[sectionIndex].input_fields.push(newObj)
      );
    }
  };

  const handleRemoveOther = (sectionIndex, subSectionIndex) => {
    if (
      !isNaN(sectionIndex) &&
      !isNaN(subSectionIndex) &&
      sectionIndex !== null &&
      subSectionIndex !== null
    ) {
      const data = _.cloneDeep(template);
      const inputFieldsData = data[sectionIndex].input_fields;
      const filledData = watchFormData.template[sectionIndex].input_fields;
      inputFieldsData.splice(subSectionIndex, 1);
      filledData.splice(subSectionIndex, 1);
      Object.assign(data[sectionIndex], {
        input_fields: [...inputFieldsData],
      });
      setValue(`template[${sectionIndex}].input_fields`, [...filledData]);
      setTemplate([...data]);
    }
  };

  useFormPageHeaderHeight(pageRef, headerRef, [templateForm, Index]);

  const handleNavigateBack = () => {
    navigate(
      `/${
        roleAccess([USER_ROLE.Sp_Standard_User]) ? "participant" : "worker"
      }-profile/${templateForm.worker_uuid}`
    );
  };

  const handleStepClick = (stepIndex) => {
    setIndex(stepIndex);
    const templateArray = _.cloneDeep(template);
    templateArray.forEach((item, i) => {
      if (i < stepIndex) {
        item.status = "complete";
      } else if (i === stepIndex) {
        item.status = "current";
      } else {
        item.status = "";
      }
    });
    setTemplate([...templateArray]);
    scrollRef.current?.scrollTo?.(0, 0);
  };

  const handlePreviousStep = () => {
    if (Index > 0) {
      handleStepClick(Index - 1);
    }
  };

  return (
    <div ref={pageRef} className='min-h-screen form-page'>
      <SideBar classes='bg-gradient' />
      <div
        className={
          sideBarPadding
            ? "min-h-screen flex flex-col lg:pl-[4rem] duration-300"
            : "min-h-screen flex flex-col lg:pl-64 duration-300"
        }
      >
        {request.isRequested ? (
          <FormPageLoader />
        ) : (
          <main className='form-fill-page'>
            <FormPageHeader
              ref={headerRef}
              title={templateForm.title}
              role="hrm"
              subtitle='Edit submission'
              showNotifications={false}
              breadcrumb={
                <FormPageBreadcrumb
                  formData={templateForm}
                  formTitle={templateForm.title}
                  parentSlug={parentSlug}
                  routeRole='hrm'
                  participantUuid={
                    templateForm?.participant_uuid ??
                    templateForm?.worker_uuid ??
                    state?.particpantUuid
                  }
                />
              }
              onBack={handleNavigateBack}
            />
            <div className='form-fill-shell'>
              <div className='form-fill-meta px-4 sm:px-6 lg:px-8 pt-3'>
                <FormMetaStrip
                  className='is-compact'
                  items={buildSubmittedFormMetaItems({
                    formData: templateForm,
                    routeRole: "hrm",
                    handleImageError,
                  })}
                />
              </div>
              <form
                className='form-fill-form'
                onSubmit={handleSubmit(
                  onSubmit,
                  dynamicFormInvalidSubmitToast
                )}
              >
                <div className='form-fill-stage'>
                  {template.length > 0 &&
                    template.map((section, index) =>
                      index === Index ? (
                        <div
                          key={`${index}-${section.section_title}`}
                          className='form-fill-panel'
                        >
                          {template.length > 1 && (
                            <div className='form-fill-stepper-bar'>
                              <Stepper
                                template={template}
                                currentIndex={Index}
                                onStepClickHandler={handleStepClick}
                              />
                            </div>
                          )}
                          <div className='form-section-card form-section-card--fill'>
                            <div
                              ref={scrollRef}
                              className='form-fill-section-body'
                            >
                              <div className='form-field-grid'>
                                <SectionInputFields
                                  setValue={setValue}
                                  section={section}
                                  register={register}
                                  control={control}
                                  watchFormData={watchFormData}
                                  index={index}
                                  errors={errors}
                                  fileUploadHandler={fileUploadHandler}
                                  fileUploadChecker={fileUploadChecker}
                                  fileLoader={fileLoader}
                                  signatures={signatures}
                                  formatIntoPngManager={formatIntoPngManager}
                                  sigCanvasManager={sigCanvasManager}
                                  clearSignatureManager={clearSignatureManager}
                                  setSelectedLegal={setSelectedLegal}
                                  delteRowHandler={delteRowHandler}
                                  addRowHandler={addRowHandler}
                                  updatedBody={updatedBody}
                                  templateForm={templateForm}
                                  setFieldName={setFieldName}
                                  participantList={participantList}
                                  setSelectedBody={setSelectedBody}
                                  setOpenBodyModal={setOpenBodyModal}
                                  handleRemoveOther={handleRemoveOther}
                                  handleAddOther={handleAddOther}
                                />
                              </div>
                            </div>
                            <div className='form-actions-bar'>
                              {Index > 0 && (
                                <div className='form-actions-bar-start'>
                                  <CustomButton
                                    type='button'
                                    label='Previous'
                                    variant='secondary'
                                    cssClass='form-btn-outline'
                                    clickHandler={handlePreviousStep}
                                    isDisabled={
                                      isSubmitting ||
                                      !fileUploadChecker ||
                                      isSaveExitLoading
                                    }
                                  />
                                </div>
                              )}
                              <div className='form-actions-bar-end'>
                                <CustomButton
                                  type='button'
                                  label='Save & Exit'
                                  variant='secondary'
                                  cssClass='form-btn-outline'
                                  clickHandler={handleSaveAndExit}
                                  isDisabled={
                                    isSubmitting ||
                                    !fileUploadChecker ||
                                    isSaveExitLoading
                                  }
                                  showLoading={isSaveExitLoading}
                                />
                                <CustomButton
                                  type='submit'
                                  label={
                                    Index < template.length - 1
                                      ? "Save & Next"
                                      : "Submit"
                                  }
                                  isDisabled={
                                    isSubmitting ||
                                    !fileUploadChecker ||
                                    isSaveExitLoading
                                  }
                                  showLoading={isSubmitting}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null
                    )}
                </div>
              </form>
            </div>

            {openBodyModal && (
              <HumanBodyModal
                selectedValue={updatedBody ? updatedBody : selectedBody}
                handleSubmit={(e) => {
                  if (e) {
                    setValue(fieldName, e);
                    setUpdateBody(e);
                    setSelectedBody(e);
                  }
                  setOpenBodyModal(false);
                }}
                isOpen={openBodyModal}
                closeModal={() => setOpenBodyModal(false)}
              />
            )}
            {selectedLegal && (
              <AlertModal
                show={selectedLegal !== ""}
                handleClose={() => setSelectedLegal("")}
              >
                {selectedLegal}
              </AlertModal>
            )}
          </main>
        )}
      </div>
    </div>
  );
};

export default SubmittedFormUpdate;
